import { createAction } from "@reduxjs/toolkit";

export const setSuccess = createAction('success/setSuccess');
export const hideSuccess = createAction('success/hideSuccess');